import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";

import NavBar from "../../components/Navbar";
import LoadingComponent from "../../components/LoadingComponent";
import { cleanUserAd } from "../../store/ducks/duckAuth";

import SearchUserInput from "./components/FormSearch";
import CardInfoDomains from "./components/CardInfoDomains";
import CardUser from "./components/CardUser";

export const SearchUser = () => {
  const { isLoading, dataDomainsInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(cleanUserAd());
    };
  }, [dispatch]);

  return (
    <>
      <NavBar withLocation />
      {isLoading && <LoadingComponent loading={isLoading} />}
      <Grid container direction="column" justify="center" style={{ minHeight: "100%" }}>
        <Grid item style={{ marginLeft: "auto", marginRight: "auto" }} xs={6}>
          <SearchUserInput />
          {dataDomainsInfo?.user?.networkUser !== null ? (
            <CardUser style={{ marginTop: 20 }} user={dataDomainsInfo?.user} />
          ) : (
            <></>
          )}
          {dataDomainsInfo?.user?.networkUser === null && (
            <Typography color="textSecondary" style={{ color: "red" }} variant="body2">
              No users found.
            </Typography>
          )}
        </Grid>
        <Grid item style={{ marginLeft: "auto", marginRight: "auto", paddingTop: 20 }} xs={6}>
          {dataDomainsInfo?.infoDomains && (
            <CardInfoDomains key="Key" domainInfo={dataDomainsInfo?.infoDomains} />
          )}
        </Grid>
      </Grid>
    </>
  );
};
